export const middlewareAPI = {
    apiCall,
    cartApiCall
}

function handleErrors(response) {
    if (!response.ok && response.status === "400") {
        return response.json();
    }
    if (!response.ok) {
        throw Error(response.status);
    }
    return response.json();
}

function apiCall(apiName, requestOptions) {
    return fetch(apiName, requestOptions)
        .then(handleErrors)
        .catch(error => ({ success: false, error: error }));
}

function cartApiCall(apiName, requestOptions) {
    return fetch(apiName, requestOptions)
        .then(handleErrors)
        .catch(error => ({ success: false, error: error }));
}

